import React from 'react';
import { StyleSheet, View } from 'react-native';
import {
  COLORS,
  HStack,
  Icon,
  SectionHeader,
  SPACING,
} from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

export const CheckoutPaymentBlockCardIcons = () => {
  const { t } = useLocalizationContext();
  const heading = t(`general.payment-method`);

  return (
    <SectionHeader heading={heading}>
      <View style={styles.iconsWrapper}>
        <HStack customSpacing={8}>
          <Icon name="IconCcVisa" color={COLORS.POTATO} />
          <Icon name="IconCcMasterCard" color={COLORS.POTATO} />
          <Icon name="IconCcDiscover" color={COLORS.POTATO} />
          <Icon name="IconCcAmex" color={COLORS.POTATO} />
        </HStack>
      </View>
    </SectionHeader>
  );
};

const styles = StyleSheet.create({
  iconsWrapper: {
    marginLeft: 'auto',
    paddingLeft: SPACING.small,
  },
});
